<template>
  <div class="d-flex align-items-center">
    <img
      :src="`${$s3}/img/common/global${white ? '_white' : ''}.svg?${$ver}`"
      class="mr-1"
      :style="[isMobile ? { height: '15px' } : {}]"
    />
    <select :class="{ my: save }" name="lang" v-model="lang">
      <option v-for="(lang, i) in $i18n.availableLocales" :key="i" :value="lang">
        {{ localeNames?.[lang] }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import localeNames from '@/plugins/i18n_locale_names.json';

const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default {
  name: 'SetLanguage',
  props: {
    save: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localeNames,
    };
  },
  computed: {
    ...mapState({
      stateLang: (state) => state.lang,
      isMobile: (state) => state.isMobile,
      isLogin: (state) => state.isLogin,
    }),
    lang: {
      get() {
        return this.stateLang;
      },
      set(val) {
        this.setLanguage(val);
      },
    },
  },
  methods: {
    ...mapMutations(['startSpinner', 'endSpinner']),
    ...mapActions(['fetchLanguage', 'saveLang']),
    async setLanguage(val) {
      this.startSpinner();
      await timeout(500);
      this.$store.commit('sidebar', { mode: 'close' });

      if (this.save && this.isLogin) await this.saveLang({ lang: val });
      else await this.fetchLanguage({ lang: val });
      this.endSpinner();
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
select {
  border: none;
  outline: none;
  background: #00000000;
  color: #333333;

  &.my {
    width: fit-content;
    height: 32px;
  }
}
</style>
